/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Stack } from '@fluentui/react/lib/Stack';
import React from 'react';
import { CalloutButton, CalloutButtonProps } from 'src/core/components/CalloutButton';
import { LuisText } from 'src/core/components/LuisText';
import { getScopedTheme, getStylistV2 } from 'src/core/themes/luisStylist';

const theme = getScopedTheme('TranslationLocalFileTable');
const { getClassName } = getStylistV2('TranslationLocalFileTable');
const labelDescriptionIconClassName = getClassName('labelDescriptionIconClassName', { fontSize: '12px' });

type TranslationDropDownLabelProps = {
    id: string;
    label: string;
    descriptionIconProps: CalloutButtonProps;
};

export const TranslationDropDownLabel = (props: TranslationDropDownLabelProps) => {
    const { id, label, descriptionIconProps } = props;

    return (
        <Stack horizontal verticalAlign="center" tokens={{ padding: '5px 0 5px 0' }}>
            <LuisText variant="medium" fontWeight={500} id={id}>
                {label}
            </LuisText>
            <CalloutButton {...descriptionIconProps} iconClassName={labelDescriptionIconClassName} />
            <LuisText variant="medium" fontWeight={500} color={theme.requiredColor}>
                *
            </LuisText>
        </Stack>
    );
};
